import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RevenueSharingContext } from '../../context-api/data-provider/RevenueSharingDataProvider';
import { Tooltip } from '@mui/material';

const ReferralStatistics = (props) => {
  const { redirect = true } = props;
  const { revenueSharingAPIResponse, googleAnalyticAPIResponse } =
    useContext(RevenueSharingContext);
  const navigate = useNavigate();
  const RedirectToReferralstatistics = () => navigate('/referralstatistics');
  const ApiFetchedDate = revenueSharingAPIResponse?.data?.data?.fetchApiDate;

  console.log('----googleAnalyticAPIResponse', googleAnalyticAPIResponse);

  function formatNumber(num) {
    if (num === null || num === undefined) return '';

    const units = [
      { value: 1_000_000_000, suffix: 'B' },
      { value: 1_000_000, suffix: 'M' },
      { value: 1_000, suffix: 'K' },
    ];

    if (num < 1000) return num;

    for (const u of units) {
      if (num >= u.value) {
        let value = (num / u.value).toFixed(1);
        value = value.endsWith('.0') ? value.slice(0, -2) : value;

        return (
          <>
            {value}
            <span style={{ fontSize: 22, fontFamily: "'Playfair Display'", fontWeight: 'bold' }}>
              {u.suffix}
            </span>
          </>
        );
      }
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        marginTop: '10px',
        cursor: 'pointer',

        // backgroundColor: '#28f363', // #FAF850' #28f363 #BDF271
        // borderBottom: '5px solid #1b2936',
        // border: '2px solid rgb(255, 123, 41)',
      }}
      onClick={() => {
        if (redirect) {
          RedirectToReferralstatistics();
        }
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px solid rgb(24, 20, 54)',
          backgroundColor: 'rgb(24, 20, 54)',
          // borderBottom: '3px solid #28f363',
          borderRadius: '5px',
          width: '580px',
          height: '100px',
        }}
      >
        <Tooltip
          title='Unique visit count reflects data from the 1st of this month up to today.'
          placement='bottom'
          arrow
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: '#1e90ff',
                  textAlign: 'center',
                  color: 'white',
                  fontFamily: 'Inter Medium',
                  fontSize: '14px',
                  fontWeight: 500,
                  height: '50px',
                },
                '& .MuiTooltip-arrow': {
                  color: '#1e90ff',
                },
              },
            },
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '20px',
              color: 'white',
            }}
          >
            <div style={{ fontFamily: 'Inter Regular', fontSize: '12px', color: 'darkgray' }}>
              Unique visits (PA567)
            </div>
            <div style={{ fontFamily: 'Playfair Display', fontSize: '28px' }}>
              {formatNumber(100)}
            </div>
          </div>
        </Tooltip>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '20px',
            color: 'white',
          }}
        >
          <div style={{ fontFamily: 'Inter Regular', fontSize: '12px', color: 'darkgray' }}>
            Subscribers
          </div>
          <div style={{ fontFamily: 'Playfair Display', fontSize: '28px' }}>
            {formatNumber(1500000)}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '20px',
            color: 'white',
          }}
        >
          <div style={{ fontFamily: 'Inter Regular', fontSize: '12px', color: 'darkgray' }}>
            Followers
          </div>
          <div style={{ fontFamily: 'Playfair Display', fontSize: '28px' }}>
            {' '}
            {formatNumber(1500)}
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '20px',
            color: 'white',
          }}
        >
          <div style={{ fontFamily: 'Inter Regular', fontSize: '12px', color: 'darkgray' }}>
            Referral Revenue
          </div>
          <div style={{ fontFamily: 'Playfair Display', fontSize: '18px', color: '#28f363' }}>
            $
            <span style={{ fontFamily: 'Playfair Display', fontSize: '24px', marginLeft: '2px' }}>
              4100
            </span>
          </div>
        </div>
      </div>
      <div style={{ fontSize: '14px', color: 'gray', fontFamily: 'Inter Light', marginTop: '5px' }}>
        {' '}
        Last updated : {ApiFetchedDate}
      </div>
    </div>
  );
};

export default ReferralStatistics;
